import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HorizontalLine } from '../../../../../../../components/shapes/Line'
import { Title } from '../../../../../../../packages/kiti/components/presentation/Text'
import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import AssetFiltersList from '../../../../../../../containers/assets/filters/AssetFiltersList'
import FilterInput from '../../../../../../../components/form/FilterInput'
import PlaceFiltersList from '../../../../../../../containers/places/filters/PlaceFiltersList'
import Separator from '../../../../../../../packages/kiti/components/helpers/Separator'
import UserFiltersList from '../../../../../../../containers/users/filters/UserFiltersList'

const FilterList = ({ questionType }) => {
  switch (questionType) {
    case 'asset':
      return <AssetFiltersList />
    case 'user':
      return <UserFiltersList />
    case 'place':
      return <PlaceFiltersList />
    default:
      return false
  }
}

const FilterSection = () => {
  const { t } = useTranslation('editChecklist')
  const { handleSelectedQuestionChangeOnPath } = useChecklistFormActions()
  const selectedQuestion = useSelectedQuestion()

  const { randomIdAfterUndo } = useChecklistFormActions()

  if (!['asset', 'user', 'place'].includes(selectedQuestion.questionType.name)) return false

  return (
    <>
      <Separator weight={6} />
      <Title size="h6" color={COLORS.dark4}>
        {t('filters')}
      </Title>
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={4} />

      {/*<CheckboxInput
        label="Mostrar somente ativos do mesmo place da atividade"
        value={selectedQuestion.data?.fromSamePlace}
        onChange={handleSelectedQuestionChangeOnPath(['data', 'fromSamePlace'])}
      /> */}

      <Separator weight={2} key={randomIdAfterUndo}>
        <FilterInput
          key={selectedQuestion.reference}
          filtersList={<FilterList questionType={selectedQuestion.questionType.name} />}
          gap={1.2}
          value={selectedQuestion.data?.filter}
          onChange={handleSelectedQuestionChangeOnPath(['data', 'filter'])}
        />
      </Separator>
    </>
  )
}

export default FilterSection
